import React from 'react';
import { cn } from '../../utils/classNames';

export const SkewedLinesBackground: React.FC = () => {
  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 z-0 h-full w-full overflow-hidden [mask-image:linear-gradient(to_bottom,white,transparent,white)]",
      )}
    >
      <svg
        className="absolute h-[200%] w-[200%] -translate-x-1/2 -translate-y-1/2"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="contact-skewed-lines"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M-10,30 L30,-10 M-20,40 L40,-20 M-10,50 L50,-10"
              className="stroke-neutral-800/20 dark:stroke-neutral-200/20"
              strokeWidth="1"
              fill="none"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#contact-skewed-lines)" />
      </svg>
    </div>
  );
}; 